"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETextStyle = void 0;
class MerchantPrinter {
}
exports.default = MerchantPrinter;
var ETextStyle;
(function (ETextStyle) {
    ETextStyle[ETextStyle["Small"] = 0] = "Small";
    ETextStyle[ETextStyle["Medium"] = 1] = "Medium";
    ETextStyle[ETextStyle["Large"] = 2] = "Large";
    ETextStyle[ETextStyle["MediumWidth"] = 3] = "MediumWidth";
    ETextStyle[ETextStyle["LargeWidth"] = 4] = "LargeWidth";
})(ETextStyle = exports.ETextStyle || (exports.ETextStyle = {}));
//# sourceMappingURL=MerchantPrinter.js.map